import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { Grid } from '@gogame/components';
import { useIsAllowed } from '@gogame/permissions';

import { PERMISSION_ACTION_MANAGE_CONVERSIONS } from 'scenes/Integrations/constants';

import * as Filters from './filters';

const AllFilters = ({ open, onClose, onExited }) => {
  const isAllowedManageConversions = useIsAllowed()(
    PERMISSION_ACTION_MANAGE_CONVERSIONS
  );

  return (
    <AllFiltersProvider open={open} onClose={onClose} onExited={onExited}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Filters.Types />
        </Grid>
        <Grid item xs={4}>
          <Filters.BusinessPartners />
        </Grid>
        <Grid item xs={4}>
          <Filters.Affiliates dropdownWidth={'440px'} />
        </Grid>
        <Grid item xs={4}>
          <Filters.Applications />
        </Grid>
        <Grid item xs={4}>
          <Filters.Events />
        </Grid>
        {isAllowedManageConversions ? (
          <Grid item xs={4}>
            <Filters.Partners />
          </Grid>
        ) : null}
        <Grid item xs={4}>
          <Filters.ActivityType />
        </Grid>
      </Grid>
    </AllFiltersProvider>
  );
};

export default AllFilters;
